import { parseLearningNavigation } from '@/features/learning/admin/learningNavigation';
import { createFileRoute } from '@tanstack/react-router';
import { LearningContentPage } from '@/features/learning/admin/LearningContentPage';
import { requireRouteAccess } from '@/lib/routeGuards';

export const Route = createFileRoute('/_authed/admin/learning')({
  beforeLoad: () => requireRouteAccess('/admin/learning'),
  validateSearch: parseLearningNavigation,
  component: function LearningRoute() {
    const search = Route.useSearch();
    const navigate = Route.useNavigate();
    return (
      <LearningContentPage
        navigation={search}
        onNavigate={(patch, replace = false, internal = false) => {
          void navigate({
            search: (previous) => ({ ...previous, ...patch }),
            replace,
            ignoreBlocker: internal,
          });
        }}
        initialTab={search.tab}
        initialPolicyId={search.policy}
      />
    );
  },
});
